<template>
  <a-modal
    :title="title"
    :width="560"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" @keyup.enter.native="handleOk">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.oldPassword')">
          <a-input-password
            type="password"
            :placeholder="$t('disp.ph.input', [$t('disp.oldPassword')])"
            v-decorator="['oldpassword', validatorRules.oldpassword]"
            :maxLength="255"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.newPassword')">
          <a-input-password
            type="password"
            :placeholder="$t('disp.ph.input', [$t('disp.newPassword')])"
            v-decorator="['password', validatorRules.password]"
            :maxLength="255"
            @blur="handleBlur"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.confirmNewPassword')">
          <a-input-password
            type="password"
            :placeholder="$t('disp.confirmNewPassword.ph')"
            v-decorator="['confirmpassword', validatorRules.confirmpassword]"
            :maxLength="255"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { putAction } from '@/api/manage'

export default {
  name: 'UserPassword',
  data() {
    return {
      title: this.$t('disp.menu.changePassword'),
      visible: false,
      loading: false,
      validatorRules: {
        oldpassword: {
          rules: [
            {
              required: true,
              message: this.$t('disp.rules.require'),
            },
          ],
        },
        password: {
          rules: [
            {
              required: true,
              message: this.$t('disp.rules.require'),
            },
            {
              pattern: /^[a-zA-Z,0-9,~!@#$%^&*()_+`\-={}:";'<>?,./\[\]\|\\]{8,}$/,
              message: this.$t('msg.E_K0014001_01'),
            },
          ],
          trigger: 'blur',
        },
        confirmpassword: {
          rules: [
            {
              required: true,
              message: this.$t('disp.rules.require'),
            },
            {
              validator: this.compareToFirstPassword,
            },
          ],
          trigger: 'blur',
        },
      },
      confirmDirty: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      form: this.$form.createForm(this),
      url: '/blaze-sys/k00/k0014/UserManage/updatePassword',
      loginUser: this.$getLoginUser(),
    }
  },
  methods: {
    show(uname) {
      if (!uname) {
        this.$message.warning('当前系统无登录用户!')
        return
      } else {
        this.form.resetFields()
        this.visible = true
      }
    },
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.disableSubmit = false
      this.selectedRole = []
    },
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const that = this
      // 触发表单验证
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          let params = Object.assign({ username: that.loginUser.username }, values)
          putAction(that.url, params)
            .then((res) => {
              if (res.success) {
                console.log(res)
                that.$message.success(that.$t(res.message))
                that.close()
              }
            })
            .finally(() => {
              that.loading = false
            })
        } else {
          that.loading = false
        }
      })
    },
    // validateToNextPassword(rule, value, callback) {
    //   const form = this.form
    //   if (value && this.confirmDirty) {
    //     form.validateFieldsAndScroll(['confirm'], { force: true })
    //   }
    //   callback()
    // },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback(this.$t('msg.E_K0014001_02'))
      } else {
        callback()
      }
    },
    handleBlur(e) {
      if (this.form.getFieldValue('confirmpassword')) {
        this.form.validateFieldsAndScroll(['confirmpassword'], { force: true })
      }
    },
  },
}
</script>

<style scoped></style>
